import React, { useState, useContext} from "react";
// Actions
import { logoutSaga } from "../../stores/Login/Action";
// Libraries
import { useSelector, useDispatch } from "react-redux";
import { ExitToApp } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
// Redux
import { getUsername } from "../../stores/Login/Selector";
import {ErrorContext} from '../../Contexts/ErrorContext'

// Components
import SideDrawerList from "../../Components/Lists/SideDrawerList/SideDrawerList";
import Toasts from "./Toasts";

// Consts
import {
  Container,
  LeftContainer,
  RightContainer,
  MenuContainer,
  MainContainer,
  Name,
  MenuImage,
  DrawerImage,
} from "./Main.css";
import appName from "../../Assets/Images/appName.png";

import {usePushNotifications} from "../../Hooks/usePushNotifications";

const Main = (props) => {
  usePushNotifications();
  const [history] = useState(useHistory());
  // State
  const name = useSelector(getUsername);

  const style = { cursor: "" };
  const {isMainLoading} = useContext(ErrorContext);

  if (isMainLoading) style.cursor = "progress";

  const dispatch = useDispatch();

  return (
    <div className={Container} style={style}>
      <div className={LeftContainer}>
        <img className={DrawerImage} alt={"App logo"} src={appName} />
        <SideDrawerList />
      </div>
      <div className={RightContainer}>
        <div className={MenuContainer}>
          <ToastProvider autoDismiss={true}>
            <Toasts />
          </ToastProvider>
          <div
            className={MenuImage}
            onClick={(e) => {
              e.preventDefault();
              dispatch(logoutSaga(history));
            }}
          >
            <ExitToApp />
          </div>
          <h4 className={Name}>{name}</h4>
        </div>
        <div className={MainContainer}>
            {props.children}
        </div>
      </div>
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/Containers/Main/Main.js